import APIConfig, { defaultPagesize } from 'config';
import AbstractService from './AbstractService';

export default class PlayListService extends AbstractService {
	static list(
		page = 1,
		pagesize = defaultPagesize,
		search = '',
		sort = '',
		summary = false
	) {
		return this.get(APIConfig.endpoints.playList, {
			page,
			pagesize,
			sort,
			filter: search,
			summary
		});
	}

	static create(playlist) {
		return this.post(APIConfig.endpoints.playList, playlist);
	}

	static updateItem(playlist) {
		return this.put({
			url: APIConfig.endpoints.playListDetail.replace('{0}', playlist.playlistid),
			data: playlist
		});
	}

	// update a track's position by putting track before or after referenceTrackid
	static updateTrackPosition({ playlistid, trackid, position, referenceTrackid }) {
		return this.put({
			url: APIConfig.endpoints.playListTracks.replace('{0}', playlistid),
			data: {
				tracks: [trackid],
				position: position,
				trackid: referenceTrackid
			}
		});
	}

	static deleteItem(id) {
		return this.del(APIConfig.endpoints.playListDetail.replace('{0}', id));
	}

	static addTracks(id, tracks) {
		return this.post(
			APIConfig.endpoints.playListTracks.replace('{0}', id),
			{
				tracks,
				position: 'before'
			}
		);
	}

	static getTracklist(playlistid) {
		return this.get(
			APIConfig.endpoints.getTracks.replace('{0}', playlistid)
		);
	}

	static generatePdfUrl(playlistid) {
		return `${
			import.meta.env.VITE_BASE_URL
		}/${APIConfig.endpoints.playlistPdf.replace('{0}', playlistid)}`;
	}

  static downloadPdf(playlistid) {
    return this.request({
      url: APIConfig.endpoints.playlistPdf.replace('{0}', playlistid),
      config: {
        responseType: 'blob',
        headers: { Accept: 'application/pdf' }
      }
    })
  }

	static getPlaylist(playlistid) {
		return this.get(
			APIConfig.endpoints.playListDetail.replace('{0}', playlistid)
		);
	}

	static deleteTrack(playlist, song) {
		return this.del(
			APIConfig.endpoints.deleteTrack
				.replace('{0}', playlist.playlistid)
				.replace('{1}', song.trackid)
		);
	}

	static deleteAllTrack(playlist) {
		return this.del(
			APIConfig.endpoints.deleteAllTracks.replace(
				'{0}',
				playlist.playlistid
			)
		);
	}

	static pin(playlist) {
		return this.post(
			APIConfig.endpoints.playlistPin.replace('{0}', playlist.playlistid)
		);
	}

	static unpin(playlist) {
		return this.del(
			APIConfig.endpoints.playlistPin.replace('{0}', playlist.playlistid)
		);
	}
}
